import axios from 'axios'
import { getClientName } from 'src/scripts/utilities'

const CONVERT_DATA = (_d) => {
  return _d.data
}

const REQ = async (STATE, _opt, _resolve, _path) => {
  // const QUESTION_PROCESS_ID = POST.GET_FREQUENCY_ID(_opt.questions)
  // const FORM_TYPE = POST.GET_FREQUENCY_ID(_opt.questions)
  // const FORM_ID = POST.GET_FREQUENCY_ID(_opt.questions)
  // const ANSWER_ID1 = POST.GET_FREQUENCY_ID(_opt.questions)
  // const ANSWER_ID2 = POST.GET_FREQUENCY_ID(_opt.questions)
  // const ANSWER_ID3 = POST.GET_FREQUENCY_ID(_opt.questions)

  // NOTE: get localStorage data
  const client_name = getClientName(STATE) || ''// eslint-disable-line camelcase
  const shop_qr = STATE.status.shopQR
  const referrer_ec = STATE.status.referrerEC
  // const shop_qr = getShopQR(STATE) || ''// eslint-disable-line camelcase
  // NOTE: nameはpostする必要がないため削除
  _opt.name && delete _opt.name

  const SEND_DATA:any = {
    question_process_id: '',
    form_type: '',
    form_id: '',
    answer_id1: '',
    answer_id2: '',
    answer_id3: '',
    ..._opt,
    client_name,
    shop_qr,
    referrer_ec
  }
  const PARAMS = new URLSearchParams(SEND_DATA)
  const RESPONCE = await axios.post(_path, PARAMS).catch((e) => {
    // console.log('catch', e.response, e.response.data)
    _resolve(CONVERT_DATA(e.response))
  })

  RESPONCE && _resolve(CONVERT_DATA(RESPONCE))
}

export const getQuestion = (_state, _opt, _resolve, _reject) => {
  const STATE = _state
  const PATH = process.env.END_QUESTION
  REQ(STATE, _opt, _resolve, PATH)
}
